<template lang="pug">
.RakugoSelect
  .content
    .description 噺家が喋る内容を入力して真打を目指しましょう！
    .menuList
      .menuListItem(
        @click="handleMenuClick('easy')"
        v-menuHoverSound
        v-menuClickSound
      ) その１
      .menuListItem(
        @click="handleMenuClick('normal')"
        v-menuHoverSound
        v-menuClickSound
      ) その２
      .menuListItem(
        @click="handleMenuClick('hard')"
        v-menuHoverSound
        v-menuClickSound
      ) その３
  km-footer(
    title="噺家になろう"
    backPath="/speedup/rakugo"
    :homeButtonEnabled="true"
    :navigationDisabled="true"
  )
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'speedup-select-page',
  components: {},
  computed: {
    ...mapState('User', {
      rank: state => state.rank,
      lvl: state => state.lvl,
      exp: state => state.exp,
      progress: state => state.progress,
      point: state => state.point,
      account: state => state.account,
      challengeResult: state => state.challenge_result
    })
  },
  methods: {
    handleMenuClick(level) {
      setTimeout(() => {
        this.$router.push(`/speedup/rakugo/player/${level}`)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.RakugoSelect {
  width: 100%;
  height: 100%;
  color: #fff;
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: calc(100% - 80px);
  font-size: 3rem;
  &::after {
    content: '';
    position: absolute;
    top: 0;
    display: block;
    width: 100%;
    height: 100%;
    background: url(../../../assets/speedup/rakugo/bg.png) center center
      no-repeat;
    background-size: cover;
    z-index: -1;
    filter: blur(5px);
  }
}

.description {
  margin: 0 0 50px 0;
  text-shadow: 0 0 5px rgba(82, 18, 119, 1);
}

.menuList {
  display: flex;

  &Item {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 15px;
    width: 200px;
    height: 200px;
    border: 10px solid rgba(82, 18, 119, 0.8);
    background: #fff;
    color: rgba(82, 18, 119, 1);
    transition-property: transform;
    &:hover {
      transform: scale(1.1);
    }
  }
}
</style>
